import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Row } from '../server/layout/Row/index';
import { Skeleton } from '../server/state/Skeleton/Skeleton';
export function PanelHeaderSkeleton({ padX = 'xl', padY = 'lg', }) {
    return (_jsxs(Row, { justify: "space-between", align: "center", style: {
            padding: `var(--space-${padY}) var(--space-${padX})`,
            borderBottom: '1px solid var(--border)',
        }, children: [_jsx(Skeleton, { width: 140, height: 20, rounded: "sm" }), _jsx(Skeleton, { width: 64, height: 32, rounded: "md" })] }));
}
//# sourceMappingURL=PanelHeader.skeleton.js.map